var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 9.64966,
    cy: 5.64869,
    r: 3.98169,
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.33204 15.1686C3.33097 14.8887 3.39358 14.6122 3.51511 14.3601C3.8965 13.5973 4.97201 13.193 5.86446 13.01C6.5081 12.8726 7.16062 12.7808 7.81717 12.7354C9.03273 12.6286 10.2553 12.6286 11.4709 12.7354C12.1274 12.7814 12.7799 12.8731 13.4236 13.01C14.316 13.193 15.3915 13.5592 15.7729 14.3601C16.0173 14.8741 16.0173 15.4708 15.7729 15.9848C15.3915 16.7857 14.316 17.1518 13.4236 17.3273C12.7807 17.4703 12.1279 17.5647 11.4709 17.6095C10.4815 17.6934 9.48752 17.7087 8.49604 17.6553C8.26721 17.6553 8.046 17.6553 7.81717 17.6095C7.16256 17.5652 6.5123 17.4709 5.87209 17.3273C4.97201 17.1518 3.90413 16.7857 3.51511 15.9848C3.3942 15.7297 3.33166 15.4509 3.33204 15.1686Z",
    stroke: "#c4c4c4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGrey);
export default __webpack_public_path__ + "static/media/profileGrey.77b4a0d19534e68c6ca9194b42358be0.svg";
export { ForwardRef as ReactComponent };